import {msg} from '@lit/localize';
import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {selectSubscribedPlan} from '../../selectors';
import {getCustomerDashboardLink} from '../../slices/planSlice';
import store from '../../store';

@customElement('arc-customer-portal-button')
export class CustomerPortalButton extends connect(store)(LitElement) {

	static properties = {
		loading: {type: String},
		dashboardLink: {type: String},
		subscribedPlan: {type: Object},
	};

	constructor() {
		super();
		this.loading = '';
		this.subscribedPlan = null;
		this.dashboardLink = null;
	}

	stateChanged(state) {
		this.dashboardLink = state.plan.dashboardLink;
		this.loading = state.plan.loading;
		this.subscribedPlan = selectSubscribedPlan(state);
	}

	async onManageSubscription() {
		const res = await store.dispatch(getCustomerDashboardLink());
		window.open(res.payload.general, 'paddle');
	}

	render() {
		return this.subscribedPlan &&
			!this.subscribedPlan.free && html`
			<arc-button
				@click=${() => this.onManageSubscription()}
				title="${msg('Manage my Subscription')}"
				type="secondary"
				?disabled="${this.loading === 'dashboardLink'}"
			></arc-button>
		`;
	}
}
